// extracted by mini-css-extract-plugin
export default {"gameBackground":"b_c","gameBackgroundClassic":"b_e"};